module.exports = "/images/consultant.png?201c8a7592fc8ad091e364a59f7c40b7";